import { createApp } from 'vue'
import '@/views/h5/styles/css-var.scss'
import Cookies from 'js-cookie'
import { setToken } from "@/utils/auth";
import 'element-plus/dist/index.css'

import 'dayjs/locale/zh-cn';// 中文语言
import { dayjs } from 'element-plus';
import '@/assets/styles/reset.css' // global css
import '@/assets/styles/element.scss'
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive
import 'virtual:uno.css'
// 注册指令
import plugins from './plugins' // plugins

import titlePlugin from './plugins/title.js'
import appLoading from './plugins/appLoading.js'
import { download } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'

import './permission' // permission control

import { useDict } from "@/composables/dict.js";

//注册全局echarts
import ECharts from 'vue-echarts';
import 'echarts';
//vxeTable
import 'xe-utils'
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
// ...可选 UI
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import { callH5Init, callNativeFn } from "@/utils/appTools";
import './utils/vconsole.js'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

// 初始化
callH5Init();
// import animated from 'animate.css';
function useTable (app) {
  app.use(VXETable).use(VxeUI)
}


// Vant 桌面端适配 在桌面端上模拟移动端 touch 事件
import '@vant/touch-emulator'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'


import 'tcplayer.js/dist/tcplayer.min.css'; // 腾讯云播放器样式

const app = createApp(App)

// 分页组件
import Pagination from '@/components/Pagination'

// 全局方法挂载
app.config.globalProperties.useDict = useDict

// 全局组件挂载
app.component('v-chart', ECharts);
app.component('Pagination', Pagination)

let baseHost = 'https://' + location.host
if (location.host.indexOf('localhost') > -1) {
  baseHost = 'https://wwwpre.rhkj.com'
}
app.provide('baseHost', baseHost); // 老网校跳转用基地址，本地则跳转测试环境(仅模拟)
import 'font-awesome/css/font-awesome.min.css'; // 引入 Font Awesome 样式




app.use(router)
app.use(store)
app.use(plugins)
app.use(titlePlugin)
app.use(appLoading)
app.use(useTable)
app.use(autoAnimatePlugin)
// app.use(animated)

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 从url参数中获取token
function getTokenForUrl() {
  const params = new URLSearchParams(window.location.search)
  console.log(params)
  const tokenFromUrl = params.get('token')
  if (tokenFromUrl) {
    setToken(tokenFromUrl)
  }
}
getTokenForUrl()


directive(app)
dayjs.locale('zh-cn')
app.mount('#app')
